import * as AccordionPrimitive from '@radix-ui/react-accordion';
import { ChevronDown } from 'lucide-react';
import { ReactNode } from 'react';
import { CollapsiblePanelProps } from '../offer-form-section/offer-form-section';

const ITEM_VALUE = 'disclosure';

export interface OfferFormDisclosureProps {
  title: string;
  hint?: string;
  panel: CollapsiblePanelProps;
  children: ReactNode;
}

/** Collapsible group inside a section, e.g. the product details. */
const OfferFormDisclosure = ({ title, hint, panel, children }: OfferFormDisclosureProps) => (
  <AccordionPrimitive.Root
    type="single"
    collapsible
    value={panel.isOpen ? ITEM_VALUE : ''}
    onValueChange={(value) => panel.onOpenChange(value === ITEM_VALUE)}
    className="rounded-xl border border-[#E4E7EC] px-4">
    <AccordionPrimitive.Item value={ITEM_VALUE}>
      <AccordionPrimitive.Header>
        <AccordionPrimitive.Trigger className="group flex w-full items-center justify-between gap-4 py-3 text-left">
          <span className="text-[14px] font-bold text-[#12282A]">
            {title}
            {hint && <span className="ml-1 font-normal text-[#888]">{hint}</span>}
          </span>
          <ChevronDown className="h-4 w-4 shrink-0 text-[#888] transition-transform duration-200 group-data-[state=open]:rotate-180" />
        </AccordionPrimitive.Trigger>
      </AccordionPrimitive.Header>
      {/* Room for the inputs' focus ring – the overflow needed by the animation would cut it off at the edges. */}
      <AccordionPrimitive.Content className="-mx-1 overflow-hidden px-1 data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
        <div className="flex flex-col gap-5 pb-4">{children}</div>
      </AccordionPrimitive.Content>
    </AccordionPrimitive.Item>
  </AccordionPrimitive.Root>
);

export default OfferFormDisclosure;
